module.exports = __webpack_public_path__ + "static/media/home-rewards-bottom.6fe0ca26.png";